import type { CustomItemsInsightsReport } from 'model/CustomItemsInsightsReport';

export interface CustomItemsInsightsReportState {
    loading: boolean;
    report: CustomItemsInsightsReport;
}

export const emptyCustomItemsInsightsReport = (): CustomItemsInsightsReport => ({
    range: { start: '', end: '' },
    totals: {
        quantity: 0,
        grossSales: 0,
        discounts: 0,
        refunds: 0,
        netSales: 0,
        allNetSales: 0
    },
    meta: {
        page: 1,
        perPage: 10,
        totalCount: 0,
        totalPages: 1
    },
    customItems: []
});

export const initialCustomItemsInsightsReportState: CustomItemsInsightsReportState = {
    loading: false,
    report: emptyCustomItemsInsightsReport()
};
